import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/anime';

export default function CategorySection() {
  const [hoveredId, setHoveredId] = useState<string | null>(null);

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            分类导航
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            探索你喜欢的类型
          </h2>
          <p className="text-sm text-foreground-500 mt-2">八种热门分类，满足你的不同口味</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-pointer"
              onMouseEnter={() => setHoveredId(cat.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl mb-4 transition-all duration-300 ${
                hoveredId === cat.id
                  ? 'bg-accent-500 text-white scale-110'
                  : 'bg-accent-100 text-accent-600'
              }`}>
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-1.5">{cat.name}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{cat.description}</p>
              <div className="mt-3 flex items-center gap-1 text-xs text-accent-600 font-medium opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                浏览全部 <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}